module.exports = __webpack_public_path__ + "static/img/085.885b62a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/085.png
// module id = iITa
// module chunks = 0